import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ArrowDown = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M6 13.9394L12 20M12 20L18 13.9394M12 20V4'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M11.25 4C11.25 3.58579 11.5858 3.25 12 3.25C12.4142 3.25001 12.75 3.58579 12.75 4V18.1758L17.4668 13.4121L17.5234 13.3604C17.8167 13.1184 18.2513 13.1332 18.5273 13.4062C18.8034 13.6795 18.823 14.1144 18.584 14.4102L18.5332 14.4668L12.5332 20.5273C12.3923 20.6696 12.2002 20.75 12 20.75C11.7998 20.75 11.6077 20.6696 11.4668 20.5273L5.4668 14.4668L5.41602 14.4102C5.17699 14.1144 5.1966 13.6795 5.47266 13.4062C5.74875 13.1332 6.18327 13.1184 6.47656 13.3604L6.53321 13.4121L11.25 18.1758V4Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
